import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { type EmailValue, LoanPartiesEmailTo } from 'components/EmailTo'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Button, Modal, Toggle } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { defaultSendSignatureInfos } from './constant'

export const ConfirmSignDialog = ({
  data,
  generatePdf,
  onConfirm,
  onClose,
}: {
  data: Record<string, any>
  generatePdf: Function
  onConfirm: (notes: string, additionalEmails: EmailValue) => Promise<void>
  onClose: Function
}) => {
  const [isReviewed, setReviewed] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [notes, setNotes] = useState('')
  const [additionalEmails, setAdditionalEmails] = useState<EmailValue>({})

  const onDownloadPdf = () => {
    generatePdf(false, true)
  }

  const onConfirmSign = async () => {
    setLoading(true)
    try {
      await onConfirm(notes, additionalEmails)
    } catch (e) {
      console.log(e)
      setLoading(false)
      return
    }

    toast('Signed request is sent successfully.', { type: 'success' })

    setLoading(false)
    onClose()
  }

  return (
    <Modal
      isOpen
      title="Purchase Advice Sign Request"
      titleOkay="Send Sign Request"
      disabled={!isReviewed}
      loading={isLoading}
      onClose={() => onClose()}
      onOk={onConfirmSign}
    >
      <div className="mv-2 w-full max-w-[750px] overflow-hidden text-md text-gray-600">
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          {Object.keys(defaultSendSignatureInfos).map((key, index) => {
            return (
              <div className="py-1.5" key={index}>
                <RenderInput
                  input={{
                    ...defaultSendSignatureInfos[key],
                    value: data[key],
                    error: '',
                    readOnly: true,
                  }}
                  Key={key}
                  onChange={() => {}}
                />
              </div>
            )
          })}
        </div>

        <div className="text-sm bg-gray-100 px-2 pb-4 rounded">
          <Button link onClick={onDownloadPdf}>
            <div className="flex items-start text-left underline text-gray-900 hover:text-shade-blue">
              - View Unsigned PDF <ArrowDownTrayIcon className="ml-1 h-4 w-4 shrink-0" />
            </div>
          </Button>
          <Toggle
            id="reviewed"
            title="I have reviewed the request"
            onChange={(value) => setReviewed(value)}
            value={isReviewed}
          />
          <div className="mt-3">
            <RenderInput
              input={{
                title: 'Notes',
                inputType: 'textarea',
                value: notes,
              }}
              Key="signRequestNotes"
              onChange={(key: string, value: string) => setNotes(value)}
            />
          </div>
          <div className="mt-3">
            <p className="text-sm font-semibold mb-1">Additional Email Recipients</p>
            <LoanPartiesEmailTo
              loanNumber={Number(data?.loanNumber) || 0}
              loadParties
              value={additionalEmails}
              data={[]}
              onChange={setAdditionalEmails}
              modalId="purchaseAdviceSellerConfirmSign"
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}
